"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Category = void 0;
var BaseEntity_1 = require("../../../models/concrete/BaseEntity");
;
var Category = /** @class */ (function (_super) {
    __extends(Category, _super);
    function Category(data) {
        var _this = _super.call(this, data) || this;
        _this.activeProductsCount = data.active_products_count;
        _this.countStep = data.count_step;
        _this.data = data.data;
        _this.depth = data.depth;
        _this.description = data.description;
        _this.text = data.text;
        _this.file = data.file;
        _this.image = data.image;
        _this.imageId = data.image_id;
        _this.imagesIds = data.images_ids;
        _this.metaDescription = data.meta_description;
        _this.metaKeywords = data.meta_keywords;
        _this.metaTitle = data.meta_title;
        _this.name = data.name;
        _this.nameOne = data.name_one;
        _this.parentId = data.parent_id;
        _this.productPriceFrom = data.product_price_from;
        _this.shortDescription = data.short_description;
        _this.showInMenu = data.show_in_menu;
        _this.slug = data.slug;
        _this.title = data.title;
        _this.unit = data.unit;
        _this.url = data.url;
        _this.featuredFilterPages = data.featuredFilterPages;
        _this.productsUpdatedAt = data.products_updated_at;
        _this.updatedAt = data.updated_at;
        var dynamicFields = __assign({}, data);
        [
            'active_products_count', 'count_step', 'data', 'depth', 'description', 'text', 'file', 'image', 'image_id', 'images_ids',
            'meta_description', 'meta_keywords', 'meta_title', 'name', 'name_one', 'parent_id', 'product_price_from', 'short_description',
            'show_in_menu', 'slug', 'title', 'unit', 'url', 'featuredFilterPages', 'products_updated_at', 'updated_at'
        ].map(function (key) {
            delete dynamicFields[key];
        });
        _this.dynamicFields = dynamicFields;
        return _this;
    }
    return Category;
}(BaseEntity_1.BaseEntity));
exports.Category = Category;
//# sourceMappingURL=Category.js.map